import http from '@/utils/services/http'

export default {
  mediaFipe (data1, data2) {
    return http.get('/api/relatorios/basicos/media-fipe?data1=' + data1 + '&data2=' + data2) // ?XDEBUG_SESSION_START=ps
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  mediaFipeComitente (data1, data2) {
    return http.get('/api/relatorios/basicos/media-mensal-comitente?data1=' + data1 + '&data2=' + data2) // ?XDEBUG_SESSION_START=ps
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  mediaFipeComitenteMes (comitente, data1, data2) {
    return http.get('/api/relatorios/basicos/comparativo-mensal-comitente/' + comitente + '?data1=' + data1 + '&data2=' + data2)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  dataComitentes () {
    return http.get('/api/relatorios/data/comitentes')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  comitentes () {
    return http.get('/api/comitentes/simple')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  gruposComitentes () {
    return http.get('/api/comitente/grupos')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  }
}



// WEBPACK FOOTER //
// ./src/domain/relatorios/services/index.js